<template>
  <lazy-dom>
    <section
      v-if="is_pro"
      @click="is_select=false">
      <template >
        <div class="item">
          <filter-top-select
            v-model="pro_type"
            :list="proList"
            @change="handleProType"></filter-top-select>
          <div
            v-if="pro_type=='referrer_normal_list'"
            class="table_group">
            <div class="fileTable table_item">
              <div class="tr bold">
                <div class="td name file_name">Pro Rewards (%)</div>
                <div class="td operation"></div>
              </div>
              <template v-if="pro_reward_list_type.length == 0">
                <div class="empty tr">No Data</div>
              </template>
              <template>
                <div
                  v-for="(item,index) in pro_reward_list_type"
                  :key="'pro_reward_list_'+index"
                  class="tr">
                  <div class="td name">
                    <div >
                      <p class="block color-dark ">{{ item.name}}</p>
                    </div>
                  </div>
                  <div class="td ">
                    <span class="">
                      {{item.referrer_reward_pct}}
                    </span>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </template>
      <div
        v-if="pro_type=='referrer_special_list'"
        class="item">
        <div
          v-if="!isAccount"
          class="flex flex-align-center mg-b-16">
          <span class="header_title">Reward Task Settings</span>
          <div class="driver-switch mg-l-10">
            <v-switch
              v-model="formData.status"
              @change="handleChangeStatus"/>
          </div>
        </div>
        <div class="header">
          <span class="flex flex-align-center ">
            <span class="header_title mg-r-15">Reward Settings</span>
            <div>
              <v-button
                gray
                stop
                @click="handleSelect('is_select')">{{selectName}}
                <i
                  class="el-icon-caret-bottom"></i>
              </v-button>
              <v-select-list
                v-model="is_select"
                :list="all_class_data"
                @select="handleSelectClass"
              ></v-select-list>
            </div>
          </span>
          <v-button
            green
            @click="handleAdd(1)">Add</v-button>
        </div>


        <div class="table_group">
          <div class="fileTable table_item">
            <div class="tr bold">
              <div class="td name file_name">Updated</div>
              <div class="td ">Product</div>
              <div class="td ">Referrer Reward</div>
              <div class="td operation"></div>
            </div>
            <template v-if="reward_list.length == 0">
              <div class="empty tr">No Data</div>
            </template>
            <template>
              <div
                v-for="(item,index) in reward_list"
                :key="index"
                class="tr">
                <div class="td name">
                  <div >
                    <p class="block color-dark fs-12 ">{{ item.updated_date.split(" ")[0]}}</p>
                    <p class="block color-dark fs-12 mg-t-3">{{ item.updated_date.split(" ")[1]}}</p>
                  </div>
                </div>
                <div class="td ">
                  <div>
                    <div class="flex">
                      <div
                        class="flex-center margin-top-flex"
                      >
                        <span
                          v-tooltip="item.company_name"
                          class="icon icon-content"
                        >
                          <img
                            :src="getOptionData('companySmallIcon', item.company_id).logo? getOptionData('companySmallIcon', item.company_id).logo: item.company_logo"
                          >
                        </span>
                        <span>
                          <span
                            class="icon icon-content"
                          >
                            <font-awesome-icon
                              :icon="getOptionName('iconOptions', item.class_id)" />
                          <!--                          <font-awesome-icon-->
                          <!--                            v-else-->
                          <!--                            icon="cube" />-->
                          </span>
                        </span>
                      </div>
                      <span class="block">{{item.class_language}}</span>
                    </div>
                    <span class="tips block gray fs-12 mg-t-3">{{item.plan_language}}</span>
                    <span class="tips block gray fs-12 mg-t-3">{{item.meta_data}}</span>
                  </div>
                </div>
                <div class="td ">
                  <span class="text-decoration">
                    {{item.reward_default}}%
                  </span>
                  <font-awesome-icon
                    class="mg-lr-4"
                    icon="chevron-right"></font-awesome-icon>
                  <span class="green">
                    {{item.reward}}%
                  </span>
                </div>
                <div class="td operation">
                  <span
                    class="pointer"
                    @click="handleEdit(item)">Edit</span>
                  <span
                    class="del pointer"
                    @click="handleDel(item)">Delete</span>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
      <div
        v-if="!isAccount"
        class="item">
        <div class="header">
          <span class="header_title">Old Client Reward Settings</span>
          <v-button
            green
            @click="handleAdd(2)">Add</v-button>
        </div>

        <div class="table_group">
          <div class="fileTable table_item">
            <div class="tr bold">
              <div class="td name file_name">Updated</div>
              <div class="td ">Product</div>
              <div class="td ">Referrer Reward</div>
              <div class="td operation"></div>
            </div>
            <template v-if="reward_old_client.length == 0">
              <div class="empty tr">No Data</div>
            </template>
            <template>
              <div
                v-for="(item,index) in reward_old_client"
                :key="index"
                class="tr">
                <div class="td name">
                  <div >
                    <p class="block color-dark fs-12 ">{{ item.updated_date.split(" ")[0]}}</p>
                    <p class="block color-dark fs-12 mg-t-3">{{ item.updated_date.split(" ")[1]}}</p>
                  </div>
                </div>
                <div class="td ">
                  <div>
                    <div class="flex">
                      <div
                        class="flex-center margin-top-flex"
                      >
                        <span
                          class="icon icon-content"
                        >
                          <img
                            :src="getOptionData('companySmallIcon', item.company_id).logo? getOptionData('companySmallIcon', item.company_id).logo: item.company_logo"
                          >
                        </span>
                        <span>
                          <span
                            class="icon icon-content"
                          >
                            <font-awesome-icon
                              :icon="getOptionName('iconOptions', item.class_id)" />
                          <!--                          <font-awesome-icon-->
                          <!--                            v-else-->
                          <!--                            icon="cube" />-->
                          </span>
                        </span>
                      </div>
                      <span class="block">{{item.class_language}}</span>
                    </div>
                    <span class="tips block gray fs-12 mg-t-3">{{item.plan_language}}</span>
                    <span class="tips block gray fs-12 mg-t-3">{{item.meta_data}}</span>
                  </div>
                </div>
                <div class="td ">
                  <span class="text-decoration">
                    {{item.reward_default}}%
                  </span>
                  <font-awesome-icon
                    class="mg-lr-4"
                    icon="chevron-right"></font-awesome-icon>
                  <span class="green">
                    {{item.reward}}%
                  </span>
                </div>
                <div class="td operation">
                  <span
                    class="pointer"
                    @click="handleEdit(item,2)">Edit</span>
                  <span
                    class="del pointer"
                    @click="handleDel(item,2)">Delete</span>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
      <reward-setting-dailog
        v-model="showSettingDialog"
        :form="rowData"
        :reward-type="reward_type"
        :productInitList="productList"
        :is-edit="isEdit"
        @update="handleUpdate"></reward-setting-dailog>
    </section>
  </lazy-dom>
</template>

<script>
import MixinOptions from '@/mixins/options'
import rewardSettingDailog from './popup/reward-setting-dailog'
import {getAccountReferrerRewardList,delAccountReferrerReward,getInsurerPlanList} from '@api/account'
import {showReferrerReward} from '@api/referral'
import FilterTopSelect from '@/views/components/filter-top-select'
export default {
  name: 'reward-setting',
  components:{
    rewardSettingDailog,
    FilterTopSelect
  },
  mixins: [MixinOptions],
  props:{
    form: {
      type: Object,
      default: () => ({})
    },
    isAccount:{
      type:Boolean,
      defalut:false
    }
  },
  data(){
    return {
      pro_type:'referrer_normal_list',
      showSettingDialog:false,
      isEdit:false,
      reward_list:[],
      class_id:11,
      reward_type:1,
      reward_old_client:[],
      rowData:{},
      productList:[],
      formData:{
        status:false
      },
      is_select:false,
      pro_reward_list:{}
    }
  },
  computed:{
    proList(){
      let {customer_profile} = this.form||{}
      let {vip_level} =customer_profile||{}
      return[
        {
          id:'referrer_normal_list',
          name:`Pro ${vip_level==0?' ⭐':''}`
        },
        {
          id:'referrer_special_list',
          name:`Pro Plus ${vip_level==1?' ⭐':''}`
          // name:'Pro Plus'
        }
      ]
    },
    pro_reward_list_type(){
      return this.pro_reward_list[this.pro_type]||[]
    },
    customerId(){
      return this.$route.query.customer_id
    },
    selectName(){
      let name = this.getOptionName('all_class_data',this.class_id)
      return name
    },
    classTypeOptions(){
      return this.globalOptions.class_data.filter(item => item.id != 90) || []
    },
    classOptions(){
      let arr = this.classTypeOptions||[]
      let data = []
      data = arr.filter(item =>item.id<50)
      return data
    },
    all_class_data(){
      return [...this.classOptions]
      // return [...this.classOptions,...this.sme_class_data]
    },
    sme_class_data(){
      let {sme_class_data} = this.globalOptions||{}
      return  sme_class_data.filter(item => [81,82,83,89,79].includes(item.id)) || []
    },
    is_pro(){
      let {customer_profile} = this.form||{}
      let {vip_level} =customer_profile||{}
      return vip_level!=-1
    }
  },
  watch:{
    form:{
      immediate:true,
      handler(val){
        let {customer_profile} = val||{}
        let {is_show_reward=false,vip_level} = customer_profile||{}
        this.formData.status = is_show_reward
        if(vip_level==0)
          this.pro_type = 'referrer_normal_list'
        if(vip_level==1)
          this.pro_type = 'referrer_special_list'
      }
    }
  },
  mounted() {
    this.handleUpdate()
  },
  methods:{
    handleProType({id}){
      this.pro_type = id
    },
    handleSelectClass({id}){
      this.class_id = id
      this.is_select = false
      this.handleUpdate()
    },
    handleSelect(){
      this.is_select =true
    },
    handleChangeStatus(){
      this.network().showReferrerReward()
    },
    handleAdd(type){
      this.isEdit = false
      this.productList =[]
      this.reward_type = type
      this.showSettingDialog = true
      this.handleUpdate()
    },
    async handleEdit(item,type){
      this.rowData = item
      this.isEdit = true
      this.reward_type = type
      let {company_id} = item
      await this.network().getInsurerPlanList({company_id})
      this.showSettingDialog = true
    },
    handleDel({id}){
      this.$ConfirmBox({
        isNewConfirm:true,
        width:500,
        title:'Delete Setting',
        confirmBtn:'Delete',
        isRed:true,
        // isGreen:true,
        message: 'Are you sure you want to delete this setting?'
      }).then(() => {
        this.network().delAccountReferrerReward({id})
      })
    },
    handleUpdate(){
      this.network().getAccountReferrerRewardList()
    },
    network(){
      return {
        getAccountReferrerRewardList: async () => {
          let params = {
            user_id: this.customerId,
            class_id:this.class_id
          }
          const {data} = await getAccountReferrerRewardList(params)
          let {reward_list,reward_old_client,pro_reward_list} = data
          this.reward_list = []
          this.reward_list = reward_list
          this.pro_reward_list = pro_reward_list
          this.reward_old_client = reward_old_client
        },
        getInsurerPlanList: async params => {
          params={
            ...params,
            hideLoading:true,
          }
          const {data} = await getInsurerPlanList(params)
          this.productList = data
        },
        delAccountReferrerReward: async (params) => {
          const {data} = await delAccountReferrerReward(params)
          this.network().getAccountReferrerRewardList()
        },
        showReferrerReward: async (params) => {
          let {status}  = this.formData||{}
          const {data} = await showReferrerReward({
            status:status?1:0,
            customer_id: this.customerId
          })
          this.$emit('update')
        },
      }
    }
  }
}
</script>

<style scoped lang="scss">
.header_title{
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #24292E;
}
.item{
  margin-top: 24px;
  .header{
    display: flex;
    justify-content: space-between;
    .header_title{
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      color: #24292E;
    }
  }
  .table_group{
    margin-top: 20px;
    .table_item{
      .tr{
        background: #FFFFFF;
        border: 1px solid #D1D5DA;
        min-height: 40px;
        display: flex;
        padding: 10px 15px;
        .td{
          flex: 1;
          display: flex;
          //align-items: center;
          font-weight: 400;
          font-size: 14px;
          min-height: 20px;
          color: #24292E;
          &.name{
            //min-width: 280px;
            max-width: 400px;
            word-break: break-word;
            .pct{
              font-weight: 600;
              font-size: 14px;
            }
          }
          &.center{
            flex: 2;
            min-width: 200px;
            justify-content: center;
          }
          &.operation{
            //min-width: 200px;
            justify-content: flex-end;
            color: #0366D6;
            .del{
              color: #CB2431;
            }
            span+span{
              margin-left: 15px;
            }
          }
          .file_name{
            font-weight: 600;
            color: #0366D6;
          }
          .icon{
            //border-radius: 100px;
            //height: 20px;
            //padding: 1px 8px;
            //margin-left: 15px;
            //font-weight: 600;
            //text-align: center;
            //min-width: 70px;
            &.green{
              border: 1px solid #28A745;
              color: #22863A;
            }
            &.gray{
              border: 1px solid #6A737D;
              color: #24292E;
            }
          }
        }
        &.bold{
          background: #F6F8FA;
          .td{
            font-weight: 600;
            font-size: 14px;
            line-height: 20px;
            color: #24292E;
          }
        }
        &.empty{
          justify-content: center;
          color: #909399;
          font-size: 14px;
        }
        &.blue_bg{
          background: #F1F8FF;
        }
        &:first-child{
          border-top-left-radius: 6px;
          border-top-right-radius: 6px;
        }
        &:last-child{
          border-bottom-left-radius: 6px;
          border-bottom-right-radius: 6px;
        }
        &+.tr{
          border-top: 0;
        }
      }
    }
    .text-decoration{
      text-decoration:line-through;
    }
    .mg-lr-4{
      margin-left: 4px;
      margin-right: 4px;
    }
    .tips{
      color: #6A737D;
    }
  }
  .icon{
    margin-right: 10px;
    img{
      height: 22px;
      width: 22px;
    }
  }
  .icon-content{
    height: 22px;
    width: 22px;
    border-radius: 5px;
    background-color: #E1E4E8;
    display: block;
    color: #6A737D;
    font-size: 14px;
    text-align: center;
    line-height: 22px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #e1e4e8;
  }
}
</style>
